module.exports = __webpack_public_path__ + "img/1227335943.fdf37175.jpg";